import { billingApi } from '../api/billingApi';

// Interfaces
export interface UserSubscriptionAlert {
  uid: string;
  email: string;
  displayName: string;
  businessName: string | null;
  endDate: Date;
  daysRemaining: number;
}

export interface SubscriptionAlerts {
  expired: {
    count: number;
    users: UserSubscriptionAlert[]; // Mantenemos el array por compatibilidad, aunque puede ir vacío si solo necesitamos el contador
  };
  expiringSoon: {
    count: number;
    users: UserSubscriptionAlert[];
  };
}

// --- Helpers de Fecha ---
// La cuenta de días vive en utils/subscriptionDates (fuente única: aviso del panel + tabla).
// Se re-exporta para no romper a quien ya la importaba desde aquí.
export { getDaysRemaining } from '../utils/subscriptionDates';

// --- Caché Simple ---
let cachedAlerts: SubscriptionAlerts | null = null;
let cacheTimestamp: number = 0;
const CACHE_DURATION = 5 * 60 * 1000; // 5 minutos

export const fetchSubscriptionAlerts = async (): Promise<SubscriptionAlerts> => {
  const now = Date.now();

  // Si hay caché reciente, lo usamos para no gastar peticiones
  if (cachedAlerts && (now - cacheTimestamp) < CACHE_DURATION) {
    return cachedAlerts;
  }

  try {
    // El adaptador REST deriva las alertas (vencidos / por vencer ≤7 días) de la
    // lista de suscripciones de la base. Misma forma de retorno que antes.
    const alerts = await billingApi.subscriptionAlerts();
    cachedAlerts = alerts;
    cacheTimestamp = now;
    return alerts;
  } catch (error) {
    console.error('Error fetching subscription alerts:', error);
    // En caso de error devolvemos 0 para no romper la UI
    return {
      expired: { count: 0, users: [] },
      expiringSoon: { count: 0, users: [] }
    };
  }
};

export const clearSubscriptionAlertsCache = (): void => {
  cachedAlerts = null;
  cacheTimestamp = 0;
};